import {
  isDefined,
  isNumber,
  NO_GROUP_ID,
  NO_GROUP_NUMBER,
} from "@timeedit/registration-shared";
import { CSSProperties, MouseEvent } from "react";
import { ConflictNotification } from "../../../Conflict";
import { WaitlistNotification } from "../../../WaitlistNotification";
import { SuccessIcon } from "./SuccessIcon";
import "./weekEvent.scss";
import { CalendarEvent } from "../../../../utils/events";
interface WeekEventProps {
  onClick: (e: MouseEvent<HTMLElement>) => void;
  style?: CSSProperties;
  event: CalendarEvent;
  className: string;
}

export function WeekEvent({
  onClick,
  event,
  style,
  className,
}: WeekEventProps): React.JSX.Element {
  const weekStyle = style ?? {};
  const leftPercentage = extractPercentageFromCalc(String(weekStyle.left));
  // The style we get from react big calendar is incomplete
  const widthPercentage = extractPercentageFromCalc(String(weekStyle.width));
  const disabled =
    event.data.groupNumber === NO_GROUP_NUMBER ||
    event.data.groupId === NO_GROUP_ID;
  return (
    <button
      className={className}
      style={{
        ...weekStyle,
        left: `${leftPercentage}%`,
        width: calculateWidth(),
        cursor: disabled ? "unset" : "pointer",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <div
        className={"rbc-event__content"}
        style={{ background: "inherit" }}
        data-reservationid={event.id}
        data-groupid={event.data.groupId}
      >
        <div>{event.title}</div>
        <div>{event.body}</div>
        <div className="week-event__footer">
          <div className="week-event__footer--withText">
            {event.footer?.wantToShowSuccess && <SuccessIcon useText={false} />}
            {event.footer?.wantToShowWaitlist && (
              <WaitlistNotification useText={false} />
            )}
            {event.footer?.wantToShowConflict && (
              <ConflictNotification useText={false} />
            )}
          </div>
          <div className="week-event__footer--withText">
            {!event.footer?.wantToShowSuccess &&
              !event.footer?.wantToShowWaitlist &&
              isDefined(event.footer) &&
              isDefined(event.footer.text) &&
              event.footer.text}
          </div>
        </div>
      </div>
    </button>
  );

  // Standard RBC width have bigger margin between events and overlaps more on
  // other days on small screens
  function calculateWidth(): string {
    return `calc(${widthPercentage}% - 1px)`;
  }
}

/**
 * @returns The first percentage value
 */
export function extractPercentageFromCalc(input: string): number {
  const regex = /calc\((\s*\d+\.?\d+)%/;
  const percentage = input.match(regex)?.[1];

  if (isDefined(percentage)) {
    const percentageValue = Number(percentage.trim());
    if (isNumber(percentageValue)) {
      return percentageValue;
    }
  }

  return 0;
}
